<div class="rti-card" [ngStyle]="style" [class.animate]="animate">
  <mat-card [attr.id]="cid" (click)="onCard($event)">
    <mat-card-header [hidden]="!hasHeader()">
      <div class="dd-card-index-container" [hidden]="!cardIndex">
        <div class="dd-card-index-layer">{{cardIndex}}</div>
      </div>
      <ng-container *ngIf="header">
        <ng-container *ngTemplateOutlet="header"></ng-container>
      </ng-container>
    </mat-card-header>
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
    <!-- <mat-card-actions [hidden]="actions.length === 0">
      <a href="#"
         class="rti-card-action"
         (click)="onAction($event, action)"
         *ngFor="let action of actions">{{action?.label}}</a>
    </mat-card-actions> -->
  </mat-card>
</div>
